import React from 'react';

interface GameTitleProps {
    title: string;
    subtitle?: string;
}

const GameTitle: React.FC<GameTitleProps> = ({ title, subtitle }) => {
    return (
        <div style={{
            textAlign: 'center',
            marginBottom: '30px',
            padding: '20px',
            paddingTop: '10px',
            paddingBottom: '10px',
            background: 'linear-gradient(135deg, rgba(101,67,33,0.9) 0%, rgba(139,69,19,0.8) 50%, rgba(160,82,45,0.7) 100%)',
            borderRadius: '15px',
            // border: '3px solid #8B4513',
            boxShadow: '0 12px 35px rgba(0,0,0,0.5), 0 0 20px rgba(139,69,19,0.3)',
            animation: 'titleGlow 2s ease-in-out infinite alternate',
            minWidth: '400px'
        }}>
            <div style={{
                color: '#8B4513',
                fontWeight: 'bold',
                marginBottom: '15px',
                textAlign: 'center',
                fontSize: '32px',
                textShadow: '2px 2px 6px rgba(0,0,0,0.8), 0 0 15px rgba(139,69,19,0.5)',
                letterSpacing: '2px'
            }}>
                🐸 {title} 🌿
            </div>
            {subtitle && (
                <div style={{
                    color: '#DEB887',
                    fontSize: '18px',
                    lineHeight: '1.4',
                    padding: '10px',
                    background: 'rgba(139,69,19,0.1)',
                    borderRadius: '8px',
                    border: '1px solid rgba(139,69,19,0.3)',
                    fontWeight: '500'
                }}>
                    {subtitle}
                </div>
            )}

            <style>{`
                @keyframes titleGlow {
                    0% { box-shadow: 0 12px 35px rgba(0,0,0,0.5), 0 0 20px rgba(139,69,19,0.3); }
                    100% { box-shadow: 0 12px 35px rgba(0,0,0,0.5), 0 0 35px rgba(139,69,19,0.5); }
                }
            `}</style>
        </div>
    );
};

export default GameTitle; 